// extracted by mini-css-extract-plugin
module.exports = {"modal-footer":"modal-footer-1sPEMXv"};